const Illegible = {
    elemName: '難読',
    type: 'inline',
    doc: '文中の難読文字をマークアップします。',
    example: '読めない■■文字',
    minContentCount: 1,
    maxContentCount: 1,
    textTemplate: '{{$text}}',
    htmlTemplate: `<span {{{$htmlId}}} class="illegible {{$classes}}">{{{$1}}}</span>`,
    xmlTemplate: `<gap {{{$xmlId}}} {{{$xmlSubtypes}}} quantity="{{$text.length}}" unit="chars" reason="illegible"/>`,
    docxTemplate: `<w:r><w:t>{{{$$1}}}</w:t></w:r>`,
    latexTemplate: '{{$text}}'
};
export default Illegible;
// export default class Illegible extends ConversionRule {
// 	get elemName() {
// 		return '難読';
// 	}
// 	toXML(node: KojiASTNode): string {
// 		const text = this.converter.convertChildren(node.children);
// 		return `<gap quantity="${text.length}" unit="chars" reason="illegible"/>`;
// 	}
// 	toText(node: KojiASTNode): string {
// 		const text = this.converter.convertChildren(node.children);
// 		return `${text}`;
// 	}
// 	toHTML(node: KojiASTNode) {
// 		const text = this.convertChildren(node.children);
// 		return `<span class="Illegible inline" >${text}</span>`;
// 	}
// }
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSWxsZWdpYmxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbnZlcnRlci9pbmxpbmVfcnVsZXMvSWxsZWdpYmxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE1BQU0sU0FBUyxHQUFtQjtJQUNqQyxRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxRQUFRO0lBQ2QsR0FBRyxFQUFFLG9CQUFvQjtJQUN6QixPQUFPLEVBQUUsVUFBVTtJQUNuQixlQUFlLEVBQUUsQ0FBQztJQUNsQixlQUFlLEVBQUUsQ0FBQztJQUNsQixZQUFZLEVBQUUsV0FBVztJQUN6QixZQUFZLEVBQUUsb0VBQW9FO0lBQ2xGLFdBQVcsRUFBRSxvR0FBb0c7SUFDakgsWUFBWSxFQUFFLGlDQUFpQztJQUMvQyxhQUFhLEVBQUUsV0FBVztDQUMxQixDQUFDO0FBRUYsZUFBZSxTQUFTLENBQUM7QUFFekIsMERBQTBEO0FBQzFELG9CQUFvQjtBQUNwQixpQkFBaUI7QUFDakIsS0FBSztBQUVMLHNDQUFzQztBQUN0QyxnRUFBZ0U7QUFDaEUsK0VBQStFO0FBQy9FLEtBQUs7QUFFTCx1Q0FBdUM7QUFDdkMsZ0VBQWdFO0FBQ2hFLHNCQUFzQjtBQUN0QixLQUFLO0FBRUwsK0JBQStCO0FBQy9CLHNEQUFzRDtBQUN0RCw2REFBNkQ7QUFDN0QsS0FBSztBQUNMLElBQUkifQ==